---
nb:
  admin:
    power_plants:
      delete_data:
        confirm_hint: Dette kan ikke angres. Skriv kraftverkets navn "{name}" for å bekrefte.
        confirm_label: Kraftverksnavn
        counts:
          downtime_days: Nedetidsdager
          downtime_events: Nedetidshendelser
          downtime_periods: Nedetidstimer
          orphaned_downtime_events: Nedetidshendelser som blir ufullstendige
          production_days: Produksjonsdager
          production_periods: Produksjonsperioder
          production_quarters: Produksjonskvarter
          revenue_periods: Inntektsperioder
          verified_downtime_events: Verifiserte nedetidshendelser
        delete: Slett data
        deleted_body: "{count} rader fjernet."
        deleted_title: Produksjonsdata slettet
        deleting: Sletter. Ikke lukk dialogen før den er ferdig.
        description: Fjerner permanent dette kraftverkets produksjons- og nedetidsdata innenfor valgt datoperiode. Forhåndsvis effekten først, bekreft deretter.
        error: Noe gikk galt. Ingen data ble slettet.
        errors:
          busy: En annen jobb skriver produksjonsdata for dette kraftverket. Ingenting ble slettet — prøv igjen om noen minutter.
        from: Fra
        menu: Slett produksjonsdata
        preview: Forhåndsvis effekt
        rows_header: Rader som slettes
        table_header: Data
        title: 'Slett produksjonsdata: {name}'
        to: Til
        verified_blocked: Perioden overlapper verifiserte nedetidshendelser, så slettingen avvises. Fjern verifiseringen eller snevre inn perioden.
